import tagTester from './_tagTester.js';

export default tagTester('RegExp');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isRegExp.js
// module id = 1902
// module chunks = 1